const websitesUsingSecondLevelDomain = ['uk', 'au', 'nz'];

function getDomain() {
    if (window.location.hostname === 'localhost') {
        return '';
    }

    const domainComponents = window.location.hostname.split('.');

    const domainComponentsItems = isWebsiteUsingSecondLevelDomain() ? 3 : 2;
    return '.' + domainComponents.slice(domainComponents.length - domainComponentsItems).join('.');

    function isWebsiteUsingSecondLevelDomain() {
        return (websitesUsingSecondLevelDomain.indexOf(domainComponents.slice(domainComponents.length - 1).toString()) >= 0);
    }
}

function isReferrerFromVistaprint() {
    if (!document.referrer || (document.referrer.indexOf('localhost')) !== -1) {
        return false;
    }

    if (document.referrer.indexOf('cimpress.auth0.com') !== -1) {
        return true;
    }

    let hostnameComponents = new URL(document.referrer).hostname.split('.')
    let lookupOffset;
    if (websitesUsingSecondLevelDomain.indexOf(hostnameComponents[hostnameComponents.length-1]) === -1) {
        lookupOffset = 2
    } else {
        lookupOffset = 3
    }

    return 'vistaprint' === hostnameComponents[hostnameComponents.length - lookupOffset].toLowerCase();
}

module.exports.getDomain = getDomain;
module.exports.isReferrerFromVistaprint = isReferrerFromVistaprint;
